module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/sales-orders/sales-orders.component.css
// module id = ./src/app/Pages/sales-orders/sales-orders.component.css
// module chunks = main